const localStorageKey = 'gameData'

export const getCurrentGameData = () => {
    return localStorage.getItem(localStorageKey) !== null ? JSON.parse(localStorage.getItem(localStorageKey)) : {};
}

export const setCurrentGameData = (boardNumber, propertyName, propertyValue) => {
    const game_data = getCurrentGameData();
    if (!game_data[boardNumber]) {
        game_data[boardNumber] = {};
    }
    game_data[boardNumber][propertyName] = propertyValue

    localStorage.setItem(localStorageKey, JSON.stringify(game_data));
}

export const getGameDataProperty = (boardNumber, propertyName) => {
    const game_data = getCurrentGameData();
    return boardNumber in game_data && propertyName in game_data[boardNumber] ? game_data[boardNumber][propertyName] : null
}